import { useContext } from 'react';

import { TopMenuContext } from './Context';

export const useGetBreadcrumbs = () => {
  const context = useContext(TopMenuContext);

  if (!context) {
    throw new Error('useGetBreadcrumbs must be used within TopMenuProvider');
  }

  return context.breadcrumbs;
};
